import { Field } from "@app/types/Cue";
import { Type } from "@app/types/enums";
import { useTextRangesWithAnnotations } from "@hooks/useTextRangesWithAnnotations";

export type SubHeadingProps = { className?: string; fields: Field[] };

export default function SubHeading({
  className,
  fields,
}: SubHeadingProps): React.ReactElement {
  const text =
    fields.find((field) => field.name === Type.SubHeadField)?.value || "";
  const heading = fields.find((field) => field.name === Type.Headings)?.value;
  const annotations =
    fields.find((field) => field.name === Type.SubHeadField)?.annotations || [];
  const HeadingTag = heading as "span" | "h2" | "h3" | "h4" | "h5" | "h6";
  const { componentToRender } = useTextRangesWithAnnotations(text, annotations);

  return (
    <HeadingTag
      className={className}
      data-story-element={Type.SubHead}
      data-testid="sub-heading-component"
    >
      {componentToRender}
    </HeadingTag>
  );
}
